<div class="modal-content" data-test="forgotPasswordModal">
  <div class="modal-header">
    <h3 class="modal-title">{{ 'login.title' | translate }}</h3>
    <button type="button" class="close" (click)="hide()" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-0">
    <cfp-login-messages
      [errorMessages]="errorMessages"
      [warningMessages]="warningMessages"
      [successMessages]="successMessages"
    />
    @if (successMessages.length === 0) {
      <form id="forgotPasswordForm" (ngSubmit)="ngForm.valid && submitForm()" [formGroup]="form" #ngForm="ngForm">
        <cfp-form-group [label]="'login.userNameOrEmail' | translate">
          <cfp-input-text
            [id]="'username'"
            [placeholder]="'login.userNameOrEmail.placeholder' | translate"
            [formControlName]="'username'"
          />
          <cfp-validation-feedback
            [control]="form.controls['currentPassword']"
            [showMessage]="ngForm.submitted && !isFieldValid('username')"
            [message]="'validation.required' | translate: { name: ('login.userNameOrEmail' | translate) }"
          />
        </cfp-form-group>
      </form>
    }
  </div>
</div>
<div class="modal-footer justify-content-start">
  @if (successMessages.length === 0) {
    <cfp-button [type]="'submit'" [disabled]="loading" [form]="'forgotPasswordForm'">
      @if (loading) {
        <span class="spinner-grow spinner-grow-sm"></span>
      }
      {{ 'login.submit' | translate }}
    </cfp-button>
  }
  @if (successMessages.length === 1) {
    <cfp-button classes="pull-left" (clicked)="hide()">
      {{ 'close.button' | translate }}
    </cfp-button>
  }
</div>
